module.exports = __webpack_public_path__ + "assets/img/A-cb0a86cf.png";